import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const Trash = props => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <path d="M24.012 11c0.642 0 1.060 0.492 1 0.94l-2 14.13c-0.043 0.605-0.33 0.903-0.937 0.93l-12.063-0.038c-0.5 0.030-0.957-0.357-1-0.893 0 0-2-13.716-2-14.13 0-0.715 0.553-0.94 1-0.94s0.918 0.144 1 0.94c0.083 0.798 2 13.178 2 13.178h10l2-13.177c0.11-0.713 0.623-0.94 1-0.94zM13.5 22.294c-0.553 0-1-0.42-1-0.94v-7.53c0-0.52 0.447-0.942 1-0.942 0.552 0 1 0.42 1 0.94v7.53c0 0.52-0.448 0.942-1 0.942zM18.5 22.294c-0.552 0-1-0.42-1-0.94v-7.53c0-0.52 0.448-0.942 1-0.942s1 0.42 1 0.94v7.53c0 0.52-0.448 0.942-1 0.942zM26 8c0.5 0 1 0.438 1 1 0 0.547-0.5 1-1 1h-20c-0.5 0-1-0.437-1-1 0-0.562 0.5-1 1-1h6v-2c0-0.553 0.61-1 1.346-1h5.333c0.735 0 1.32 0.447 1.32 1v2h6zM14 8h4v-1h-4v1z" />
  </SvgIcon>
);

export default Trash;
